module.exports = __webpack_public_path__ + "static/media/RollCall_Product_Mockup_small.ad0cf101.png";